export default __webpack_public_path__ + "static/media/marker-turquoise.996756e4.svg";